export default __webpack_public_path__ + "static/media/notification1.6c84a7d0.svg";